var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFloor = function SvgFloor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24.806,
    height: 23.766,
    viewBox: "0 0 24.806 23.766"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_114",
    "data-name": "Rectangle 114",
    width: 24.806,
    height: 23.766,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#cfded7",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_56",
    "data-name": "Line 56",
    x1: 7.72,
    y1: 7.72,
    transform: "translate(16.733 0.354)",
    fill: "none",
    stroke: "#cfded7",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("line", {
    id: "Line_57",
    "data-name": "Line 57",
    y2: 8.344,
    transform: "translate(15.265 8.074)",
    fill: "none",
    stroke: "#cfded7",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_58",
    "data-name": "Line 58",
    y2: 8.344,
    transform: "translate(22.613 15.422)",
    fill: "none",
    stroke: "#cfded7",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_59",
    "data-name": "Line 59",
    y2: 8.344,
    transform: "translate(7.859 0.667)",
    fill: "none",
    stroke: "#cfded7",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("line", {
    id: "Line_60",
    "data-name": "Line 60",
    x1: 8.344,
    transform: "translate(7.385 8.537)",
    fill: "none",
    stroke: "#cfded7",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_61",
    "data-name": "Line 61",
    x1: 8.344,
    transform: "translate(14.77 15.922)",
    fill: "none",
    stroke: "#cfded7",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_62",
    "data-name": "Line 62",
    x1: 8.344,
    transform: "translate(0 1.152)",
    fill: "none",
    stroke: "#cfded7",
    strokeWidth: 1
  }))))));
};

export { SvgFloor as ReactComponent };
export default "data:image/svg+xml;base64,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";